//import LayoutCentered from '@/layout/LayoutCentered';
import LayoutFull from '@/layout/LayoutFull';
import ReportList from '@/components/pages/reports/ReportList';
import ReportSales from '@/components/pages/reports/ReportSales';
import ReportDealerSales from '@/components/pages/reports/ReportDealerSales';
import ReportDispatchSales from '@/components/pages/reports/ReportDispatchSales';
import ReportCdPosterPerformance from '@/components/pages/reports/ReportCdPosterPerformance';
import ReportCarriers from '@/components/pages/reports/ReportCarriers';
import BalanceIssues from '@/components/pages/reports/BalanceIssues';
import AccountsPayable from '@/components/pages/reports/AccountsPayable';
import ReportLeads from '@/components/pages/reports/ReportLeads';
import ReportFollowups from '@/components/pages/reports/ReportFollowups';
import ReportCancellation from '@/components/pages/reports/ReportCancellation';
import ReportAgentSourceSales from '@/components/pages/reports/ReportAgentSourceSales';
import ReportOrders from '@/components/pages/reports/ReportOrders';
import ReportPayments from '@/components/pages/reports/ReportPayments';
import ReportQuotes from '@/components/pages/reports/ReportQuotes';

export default [
  {
    path: '/reports',
    component: LayoutFull,
    meta: {
      auth: true,
      requirePermission: 'reports',
    },
    children: [
      {
        path: '',
        name: 'ReportList',
        component: ReportList,
      },
      { path: 'orders', name: 'ReportOrders', component: ReportOrders },
      { path: 'sales', name: 'ReportSales', component: ReportSales },
      { path: 'dispatch', name: 'ReportDispatchSales', component: ReportDispatchSales },
      { path: 'cd-poster-performance', name: 'ReportCdPosterPerformance', component: ReportCdPosterPerformance },
      { path: 'carriers', name: 'ReportCarriers', component: ReportCarriers },
      { path: 'leads', name: 'ReportLeads', component: ReportLeads },
      { path: 'quotes', name: 'ReportQuotes', component: ReportQuotes },
      { path: 'followups', name: 'ReportFollowups', component: ReportFollowups },
      { path: 'cancellation', name: 'ReportCancellation', component: ReportCancellation },
      { path: 'balance-issues', name: 'ReportBalanceIssues', component: BalanceIssues },
      { path: 'accounts-payable', name: 'ReportAccountsPayable', component: AccountsPayable },
      { path: 'agent-source-sales', name: 'ReportAgentSourceSales', component: ReportAgentSourceSales },
      { path: 'dealer-sales', name: 'ReportDealerSales', component: ReportDealerSales },
      { path: 'payments', name: 'ReportPayments', component: ReportPayments },
    ],
  },
];
